import React from "react";
import { withStyles } from '@material-ui/core/styles';
import Cell from "../Cell";
import profileMaleIcon from '../../../images/calendar/profileMale.svg';
import SmallSemiTruckIcon from '../../../images/calendar/smallSemiTruckIcon.js';

function styles () {
	return {
		driverName : {
			whiteSpace : 'nowrap',
			fontWeight : 600,
			color : '#333'
		},
		profileMaleIcon : {
			display: 'inline-block',
			width: 31,
			height: 31,
			backgroundImage: `url('${profileMaleIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight : 5,
		},
		container : {
			padding : '4px 7px',
			display : 'flex',
			alignItems : 'center',
		},
		containerForDriverRoom : {
			padding : '2px 7px',
			display : 'flex',
			alignItems : 'center',
			fontSize : '110%',
		},
		truckInfo : {
			fontSize : 14,
			color : '#555',
			display: 'flex',
			alignItems: 'center',
		},
		smallSemiTruckIcon : {
			display: 'inline-block',
			width: 11,
			height: 11,
			verticalAlign: 'middle',
			marginRight : 5,
		},
	}
}

function UserRowHeader(props) {
	const { display, subDisplay, classes, isOdd, isDriverRoom} = props;

	if (isDriverRoom) {
		return (
			<Cell isOdd={isOdd} isDriverRoom={isDriverRoom}>
				<div className={classes.containerForDriverRoom}>
					<div className={classes.driverName}>{display}</div>
				</div>
			</Cell>
		);
	}

	return (
		<Cell isOdd={isOdd}>
			<div className={classes.container}>
				<div className={classes.profileMaleIcon} />
				<div>
					<div className={classes.driverName}>{display}</div>
					<div className={classes.truckInfo}>
						<SmallSemiTruckIcon fill={'#666'} className={classes.smallSemiTruckIcon} />
						{subDisplay}
					</div>
				</div>
			</div>
		</Cell>
	);
}

export default withStyles(styles)(UserRowHeader);